<template>
  <ai-carousel-card-only
    id="kidsAndFamilyActivities"
    v-model="currentStep"
    access-id="kidsAndFamilyActivitiesCarousel"
    :items="items"
    :title="$t('hotel.kidsAndFamilyActivities.title')"
    :gutter="gutter"
    mobile-button
    :slide-width="slideWidth"
    :component="AiCardLearnMore"
    :aria-label="
      $t('accessibility.description.carouselKidsAndFamilyActivities')
    " />
</template>

<script setup lang="ts">
import type { HotelKidActivityFragment } from '~~/domains/graphql';
import AiCardLearnMore from '~~/domains/ux/molecules/AiCard/AiCardLearnMore.vue';

interface Props {
  cards: HotelKidActivityFragment[];
}

const props = defineProps<Props>();
const isSmallDevice = useMatchMediaQuery('tablet');
const isDesktopDevice = useMatchMediaQuery('large-desktop');

const gutter = computed(() => {
  if (isSmallDevice.value) return 16;

  return isDesktopDevice.value ? 64 : 32;
});
const slideWidth = computed(() => (isSmallDevice.value ? 0.9 : 0.333));

const currentStep = ref<number>(1);

const items = computed(() =>
  props.cards.map(item => ({
    description: item.introduction,
    label: item.goldSticker?.label,
    learnMoreUrl: item.learnMoreUrl,
    picture: item.picto,
    title: item.title,
    titleCapitalized: true,
    lazyLoadImage: true,
  })),
);
</script>
